import { Avatar, Box, Button, Divider, IconButton, Link, ListItemText, Stack, styled } from "@mui/material"
import { checkToken, checkUserType, FILE_PATH_URI } from "../../../utils/helper"
import { useDispatch, useSelector } from "react-redux"
import { Link as NavLink } from "react-router-dom"
import Images from "../../../assets/js/Images"
import Icons from "../../../assets/js/Icons"
import { Fragment, useState } from "react"
import SidebarMenu from "./SidebarMenu"
import { menus } from "../Header/data"
import UserServices from "../../../services/user.service"
import { clearFcmTokenOnBackend } from "../../../services/firebase.service"

const Image = styled("img")(() => ({}))
const SidebarContainer = styled("div")(() => ({
  top: "0",
  bottom: "0",
  zIndex: "200",
  width: "300px",
  color: "white",
  height: "100%",
  display: "flex",
  position: "fixed",
  overflowY: "auto",
  flexDirection: "column",
  backgroundColor: "white",
  transitionDuration: "350ms",
}))

function Sidebar({ active, sidebarDeActive }) {
  const dispatch = useDispatch()
  const userType = checkUserType()
  const userServices = new UserServices()
  const [activeIndex, setActiveIndex] = useState(null)
  const currentRole = userType === false ? "guest" : userType
  const { member, specialist } = useSelector((state) => state.authSlice)

  // Dynamically compute menus with Dashboard when authenticated
  const authChecked = checkToken(dispatch)
  const allMenus = authChecked?.valid
    ? [
      menus[0], // home
      { name: "dashboard", path: `/${userType}/profile` },
      ...menus.slice(1), // rest of menus
    ]
    : menus;

  if (menus?.roles && !menus.roles.includes(currentRole)) {
    return null
  }

  // Handle logout
  const handleLogout = async () => {
    try {
      await clearFcmTokenOnBackend();
    } catch (e) {
      console.error(e);
    }
    dispatch({ type: "Logout", payload: {} });
  };

  return (
    <Fragment>
      {active && (
        <Box
          sx={{
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            zIndex: "100",
            position: "fixed",
            bgcolor: "#00000080",
          }}
          onClick={sidebarDeActive}
        />
      )}
      <SidebarContainer
        as="aside"
        className="custom-scroller"
        sx={{
          display: { desktop: "none" },
          left: { xs: active ? "0" : "-120%" },
        }}
      >
        <Box sx={{ textAlign: "center", py: 4, px: 2 }}>
          <Link
            to="/"
            component={NavLink}
            sx={{ display: "inline-block" }}
          >
            <Image
              sx={{
                height: "50px",
                width: "100%",
                objectFit: "contain",
              }}
              alt="logo"
              src={Images?.mainLogo}
            />
          </Link>
        </Box>

        <Stack sx={{ px: 2 }} spacing={1}>
          {checkToken(dispatch)?.valid &&
            <>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar
                  src={
                    member?.image ||
                    (specialist?.profile?.profilePhoto
                      ? `${FILE_PATH_URI}${specialist.profile.profilePhoto}`
                      : (specialist?.specialist?.image || specialist?.image) !== `${FILE_PATH_URI}undefined`
                        ? (specialist?.specialist?.image || specialist?.image)
                        : "")
                  }
                  sx={{
                    width: 40,
                    height: 40,
                  }}
                />
                <ListItemText
                  sx={{ m: 0 }}
                  primary={userServices.isMember ? member?.fullName : (specialist?.specialist?.fullName || specialist?.fullName)}
                  secondary={userServices.isMember ? ("@" + member?.username) : ""}
                  slotProps={{
                    primary: { sx: { fontWeight: "500", lineHeight: 1.3, textTransform: "capitalize", color: "#223645" } },
                    secondary: { style: { fontSize: 13, lineHeight: 1 }, component: "div", color: "#223645" },
                  }}
                />
              </Box>
              <Divider />
            </>
          }
          {allMenus?.map((menu, i) => (
            <SidebarMenu
              key={i}
              index={i}
              menu={menu}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              sidebarDeActive={sidebarDeActive}
            />
          ))}
          {checkToken(dispatch)?.valid &&
            <Button
              color="dark"
              disableRipple
              onClick={handleLogout}
              sx={{ textTransform: "capitalize", justifyContent: "start" }}
            >Logout
            </Button>
          }
          {!checkToken(dispatch)?.valid &&
            <Stack spacing={{ xs: "5px", xxl: 2 }} direction="row">
              <Button
                sx={{
                  fontWeight: "400",
                  letterSpacing: "0",
                  justifyContent: "center",
                  minWidth: { xs: "95px", xxl: "110px" },
                }}
                to="/login"
                color="primary"
                variant="contained"
                LinkComponent={NavLink}
                onClick={sidebarDeActive}
              >
                Log In
              </Button>
              <Button
                sx={{
                  letterSpacing: "0",
                  fontWeight: "400",
                  justifyContent: "center",
                  minWidth: { xs: "95px", xxl: "110px" },
                }}
                to="/register"
                color="secondary"
                variant="contained"
                onClick={sidebarDeActive}
                LinkComponent={NavLink}
              >
                Register
              </Button>
            </Stack>
          }
        </Stack>
        <IconButton
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
          onClick={sidebarDeActive}
        >
          <Icons.Cross />
        </IconButton>
      </SidebarContainer>
    </Fragment>
  )
}

export default Sidebar
